<script>
import SvgIcon from "@/components/Image/SvgIcon.vue";
import DeleteIcon from "@/assets/images/misc/delete.svg";
import ActivateIcon from "@/assets/images/misc/activate.svg";
import DotsIcon from "@/assets/images/misc/h-options.svg";
import DeactivateIcon from "@/assets/images/misc/deactivate.svg";
import EditIcon from "@/assets/images/misc/edit.svg";
import FeaturedIcon from "@/assets/images/misc/featured.svg";
import FeatureIcon from "@/assets/images/misc/feature.svg";

export default {
  name: "VenueCard",
  components: {FeatureIcon, FeaturedIcon, DeactivateIcon, ActivateIcon, DotsIcon, DeleteIcon, SvgIcon, EditIcon},
  props: {
    venue: {
      default: null,
    },
  },
  computed: {
    cities() {
      return this.$store.getters.getCities.data;
    },
  },
  methods: {
    editVenues(id) {
      this.$emit('editVenues', id);
    },
    deleteVenue(id) {
      this.$emit('deleteVenue', id);
    },
    changeVenueStatus(id) {
      this.$emit('changeVenueStatus', id);
    },
    changeFeaturedStatus(id) {
      this.$emit('changeFeaturedStatus', id);
    },
  }
}
</script>

<template>
  <div v-if="venue" class="shadow-2 bordered rounded-lg p-4 relative bg-white">
    <v-btn
        :ripple="false"
        absolute
        right
        top
        class="d-inline-block text-truncate options-feature"
        text
        @click="changeFeaturedStatus(venue.id)"
    >
      <FeaturedIcon v-if="venue.is_featured === 1"/>
      <FeatureIcon v-else/>
    </v-btn>
    <v-menu
        absolute
        content-class="q-menu"
        right
        bottom
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
            :ripple="false"
            absolute
            class="text_capitalize options"
            elevation="0"
            right
            top
            v-bind="attrs"
            v-on="on"
            tile
        >
          <DotsIcon/>
        </v-btn>
      </template>
      <v-list>
        <v-list-item class="my-1" @click="editVenues(venue.id)">
          <SvgIcon text="Edit"
                   class="font-medium text-sm gap-x-2">
            <template #icon>
              <EditIcon/>
            </template>
          </SvgIcon>
        </v-list-item>
        <v-list-item class="my-1" @click="changeVenueStatus(venue.id)">
          <SvgIcon :text="venue.status_id == 1 ? 'Deactivate' : 'Activate'"
                   :class="{'svg-stroke-green':venue.status_id === 1,'svg-stroke-red':venue.status_id === 2}"
                   class="font-medium text-sm gap-x-2">
            <template #icon>
              <ActivateIcon v-if="venue.status_id !== 2"/>
              <DeactivateIcon v-else/>
            </template>
          </SvgIcon
          >
        </v-list-item>
        <v-divider/>
        <v-list-item class="my-1" @click="deleteVenue(venue.id)">
          <SvgIcon text="Delete" class="font-medium text-sm gap-x-2"
                   :class="{'red--text svg-stroke-red':venue.status_id === 1}"
          >
            <template #icon>
              <DeleteIcon/>
            </template>
          </SvgIcon>
        </v-list-item>
      </v-list>
    </v-menu>


    <v-row>
      <v-col md="4" sm="12">
        <view-image
            :absolute-src="venue.profile_image"
            class="rounded-lg bordered p-2"
            :width="100"
        />
      </v-col>
      <v-col md="8" sm="12">
        <!--        <span class="city-name">-->
        <!--          {{ cityName }}-->
        <!--        </span>-->
        <h3 class="line-clamp-1 mt-5">
          {{ venue.venue_name }}
        </h3>
        <p class="mb-2 line-clamp-1 text-neon">
          {{ venue.email }}
        </p>
        <div class="d-flex justify-space-between align-center">
          <p class="mb-2 text-dark-gray text-sm">Phone</p>
          <p class="mb-2 text-sm">
            <template v-if="venue.phone">
              {{ venue.phone }}
            </template>
            <template v-else>
              -
            </template>
          </p>
        </div>
        <div class="d-flex justify-space-between align-center">
          <p class="mb-2 text-dark-gray text-sm">Date Created</p>
          <p class="mb-2 text-sm">
            <template v-if="venue.starts_at">
              {{ venue.starts_at | dateformat }}
            </template>
            <template v-else>
              -
            </template>
          </p>
        </div>
      </v-col>
    </v-row>
    <v-divider class="my-4"/>
    <v-row class="text-center">
      <v-col md="6">
        <p class="mb-2 text-dark-gray text-sm">Rate per transaction</p>
        <p class="mb-2 text-sm text-blue font-medium">
          {{ (venue.commission_pct || 0) | numberFormatter }}%
        </p>
      </v-col>
      <v-col md="6">
        <p class="mb-2 text-dark-gray text-sm">Fee per transaction</p>
        <p class="mb-2 text-sm text-blue font-medium">
          {{ (venue.commission_extra || 0) | toCurrency }}
        </p>
      </v-col>
    </v-row>
  </div>
</template>

<style lang="scss" scoped>
.about-to-expire {
  background: #ff000026;
}

.city-name {
  position: absolute;
  right: 0;
  top: 0;
  border-radius: 0 0.5rem;
  background: #112A46;
  padding: 5px;
  color: white;
  font-size: 12px;
  min-width: 70px;
  text-align: center;
}


.options {
  &,&:hover{
    background-color: transparent !important;
  }
  min-width: 26px !important;
  height: 26px !important;
  padding: 2px !important;
  top:10px !important;
}

.options-feature {
  &,&:hover{
    background-color: transparent !important;
  }
  min-width: 26px !important;
  height: 26px !important;
  padding: 2px !important;
  top:10px !important;
  right:45px !important;
}

</style>